module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fundo fill-height",
    style: (_vm.fundo)
  }, [_c('v-container', {
    attrs: {
      "fixed": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "flex": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "elevation-12",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [(_vm.logoApp) ? _c('v-card-media', {
    attrs: {
      "src": _vm.logoApp,
      "height": "120px",
      "contain": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sucesso || _vm.mensagem) ? _c('v-card-text', [(_vm.sucesso) ? _c('h3', {
    staticClass: "title primary--text font-weight-light my-3"
  }, [_vm._v("Solicitação feita com sucesso!")]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "primary--text font-weight-light my-3"
  }, [_vm._v(_vm._s(_vm.mensagem))])]) : (!_vm.emailCode && !_vm.usuario) ? _c('v-card-text', [_c('v-form', {
    ref: "formEmail",
    attrs: {
      "validate": ""
    },
    model: {
      value: (_vm.validEmail),
      callback: function($$v) {
        _vm.validEmail = $$v
      },
      expression: "validEmail"
    }
  }, [_c('h3', {
    staticClass: "title primary--text font-weight-light my-3"
  }, [_vm._v("Solicitar Alteração de Senha")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "placeholder": "nome@email.com.br",
      "rules": _vm.emailRules,
      "hint": "Informe o e-mail da conta que deseja redefinir a senha",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/login",
      "color": "secondary"
    }
  }, [_vm._v("cancelar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "disabled": !_vm.validEmail,
      "color": "primary"
    },
    on: {
      "click": _vm.solicitarAlteracao
    }
  }, [_vm._v("Enviar E-mail")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.emailCode && !_vm.emailCode.dataAlteracao) ? _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "mb-3 title secondary--text font-weight-light"
  }, [_vm._v("Defina sua nova senha de acesso.")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "senha",
      "label": "Senha",
      "id": "senha",
      "required": "",
      "rules": _vm.senhaRules,
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.senha),
      callback: function($$v) {
        _vm.senha = $$v
      },
      expression: "senha"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "confirmacaoPassword",
      "label": "Confirmação de Senha",
      "id": "confirmacaoPassword",
      "required": "",
      "rules": _vm.csenhaRules,
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    on: {
      "click:append": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); }
    },
    model: {
      value: (_vm.csenha),
      callback: function($$v) {
        _vm.csenha = $$v
      },
      expression: "csenha"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.valid,
      "color": "primary"
    },
    on: {
      "click": _vm.trocarSenha
    }
  }, [_vm._v(" Confirmar ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.usuario && !_vm.emailCode) ? _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.validUsuario),
      callback: function($$v) {
        _vm.validUsuario = $$v
      },
      expression: "validUsuario"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "mb-3 title secondary--text font-weight-light"
  }, [_vm._v("Defina sua nova senha de acesso.")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.usuarioLogado && !_vm.usuarioLogado.email) ? _c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "placeholder": "nome@email.com.br",
      "rules": _vm.emailRules,
      "hint": "Informe o e-mail da conta que deseja redefinir a senha",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Senha Atual",
      "id": "password",
      "required": "",
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "senha",
      "label": "Nova Senha",
      "id": "senha",
      "required": "",
      "rules": _vm.senhaRules,
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.senha),
      callback: function($$v) {
        _vm.senha = $$v
      },
      expression: "senha"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "confirmacaoPassword",
      "label": "Confirmação de Nova Senha",
      "id": "confirmacaoPassword",
      "required": "",
      "rules": _vm.csenhaRules,
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    on: {
      "click:append": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); }
    },
    model: {
      value: (_vm.csenha),
      callback: function($$v) {
        _vm.csenha = $$v
      },
      expression: "csenha"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.validUsuario,
      "color": "primary"
    },
    on: {
      "click": _vm.trocarSenhaLogado
    }
  }, [_vm._v(" Confirmar ")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.textAlerta) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-028e6389"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RedefinirSenha.vue
// module id = 354
// module chunks = 1